import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import { LoadingData } from "../category/categoryActions";
import actionPlanDataAccess from "src/dataAccess/actionPlan/actionPlanDataAccess";
import { notification } from "antd";
import { ActionPlanCountModel } from "src/Layout/props.interface";
import { ActionPlanCountMap } from "src/models/actionPlan.model";

export interface ActionPlanListType extends IListType {
  status?: string;
}

export const getSupplierActionPlanListSuccess = createAction<any>(
  "[Supplier] Get Supplier Action Plan List Success"
);

export const getSupplierActionPlanListAsync = createAsyncThunk<any, ActionPlanListType>(
  "[Supplier] Get Supplier Action Plan List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(LoadingData(true));
    const result = await actionPlanDataAccess
      .getSupplierActionPlanList({
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        filters: parameter.filters,
        sortData: parameter.sortData,
        status: parameter.status,
      })
      .then((res) => {
        thunkAPI.dispatch(getSupplierActionPlanListSuccess(res));
        thunkAPI.dispatch(LoadingData(false));
        return res;
      });
    return result;
  }
);

export const saveActionPlanListSuccess = createAction<any>(
  "[Supplier] Save Action Plan Success"
);

export const deleteActionPlanAsync = createAsyncThunk<any, number | number[]>(
  "[ActionPlan] Delete Action Plan(s)",
  async (actionPlanIdOrIds, thunkAPI) => {
    const idsToDelete: number[] = Array.isArray(actionPlanIdOrIds)
      ? actionPlanIdOrIds
      : [actionPlanIdOrIds];

    await actionPlanDataAccess.deleteActionPlan(idsToDelete);

    const count = idsToDelete.length;
    const message = `${count} action plan${count === 1 ? "" : "s"} deleted successfully`;

    notification.success({ message });
    thunkAPI.dispatch(deleteActionPlanSuccess(idsToDelete));
    return idsToDelete;
  }
);


export const deleteActionPlanSuccess = createAction<number[]>(
  "[ActionPlan] Delete Action Plan Success"
);

export const GetActionPlanCountAsync = createAsyncThunk<any>(
  "[ActionPlan] Get Action Plan count",
  async () => {
    const result: ActionPlanCountModel = await actionPlanDataAccess
      .getActionPlanCounts()
      .then((res) => res?.data);
    const [counts]: any = result;
    let payload: ActionPlanCountMap = {
      actionPlan: {
        allCount: counts?.allCount,
        outstandingCount: counts?.outstandingCount,
        overdueCount: counts?.overdueCount,
      },
    };

    return payload;
  }
);
